import { useEffect } from "react";
import { useAppDispatch } from "../store/hooks";
import { EventsActions } from "../store/events-slice";
import { getEffectiveToday } from "../components/helpers/DateHelper";

const DAY_ROLLOVER_HOUR = 4;

const msUntilNextRollover = () => {
  const now = new Date();
  const next = new Date(now);
  next.setHours(DAY_ROLLOVER_HOUR, 0, 0, 0);
  if (next.getTime() <= now.getTime()) {
    next.setDate(next.getDate() + 1);
  }
  return next.getTime() - now.getTime();
};

// keeps the app's notion of "today" current even if the tab is left open
// across the day-rollover boundary, without requiring a page refresh
const useDayRollover = (isAuth: string | null) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!isAuth) return;

    let rolloverTimeout: ReturnType<typeof setTimeout>;

    const scheduleNextRollover = () => {
      rolloverTimeout = setTimeout(() => {
        dispatch(EventsActions.setEffectiveToday({ date: getEffectiveToday() }));
        scheduleNextRollover();
      }, msUntilNextRollover());
    };

    scheduleNextRollover();

    return () => clearTimeout(rolloverTimeout);
  }, [isAuth, dispatch]);
};

export default useDayRollover;
